export class AppError extends Error {
  constructor(message: string, error?: any) {
    super(message); // 'Error' breaks prototype chain here
    this.name = this.constructor.name; // Set the name
    Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain
  }
}
